import { useEffect, useState } from 'react';
import { Category } from '../products-page/components/products-categories/models/Category.model';
import styles from './SecondLevelProductCard.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { getDimensionedImage, getProductImageUrl } from '../../shared/services/get-attachments.service';
import { EMPTY_GUID } from '../../shared/constants/images-resolution.constants';
import { htmlId } from './second-level-product-card.service';
import { default as globalStyles } from '../../global-styles.module.scss';
import classNames from 'classnames';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import * as authService from '../../auth/services/auth.service';
import noImage from '../../assets/img/Fixcenter-noimage.png';
import { useTranslation } from '../../i18n/useTranslation';

interface Props {
    product: Category;
    categoryName?: string;
}

export default function SecondLevelProductCard({ product }: Props) {
    const { t } = useTranslation('translation');
    const { categoryName } = useParams();
    const { categoryId } = useParams();
    const navigate = useNavigate();

    const checkIfIsLoggedIn = (): boolean => {
        const isLoggedIn: boolean = authService.checkLogInStatus();
        return isLoggedIn;
    };

    const openProduct = () => {
        if (!product.isDirectory) {
            navigate(
                `/webshop/product/${product.routeCatagoryName ? product.routeCatagoryName : categoryName}/${product.parentProductId}/${product.id}`
            );
        } else {
            navigate(
                checkIfIsLoggedIn()
                    ? `/webshop/category/${categoryName}/directory/${product.name}/${categoryId}/${product.id}`
                    : '/login'
            );
        }
    };

    return (
        <div className={styles.container}>
            <button
                id={`${htmlId}-link-to-btn`}
                className={classNames(
                    globalStyles.default_button_style,
                    globalStyles.flex_center_item,
                    globalStyles.mb_3
                )}
                onClick={openProduct}
            >
                <section className={styles.folder_section}>
                    {product.isDirectory && (
                        <FolderCopyIcon
                            className={`${styles.folder_icon} ${styles.folder_icon_no_image}`}
                        ></FolderCopyIcon>
                    )}
                    {product && product.imageIds && product.imageIds[0] ? (
                        <img
                            src={getProductImageUrl(product.imageIds[0])}
                            loading="lazy"
                            alt={t('Product') as string}
                            className={`${globalStyles.mb_3} ${styles.no_img}`}
                        />
                    ) : (
                        <img
                            src={noImage}
                            loading="lazy"
                            alt={t('Product') as string}
                            className={`${globalStyles.mb_3} ${styles.no_img}`}
                        />
                    )}
                    <label className={styles.product_name}>
                        {product.translation ? product.translation : product.name}
                    </label>
                </section>
            </button>
        </div>
    );
}
